let httpErrorSink = null;

export function newRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '');
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2, 10)}`;
}

export function requestIdFromError(err) {
  const reqHeaders = err?.config?.headers || {};
  const resHeaders = err?.response?.headers || {};
  return (
    reqHeaders['X-Request-ID'] ||
    reqHeaders['x-request-id'] ||
    resHeaders['x-request-id'] ||
    resHeaders['X-Request-ID'] ||
    null
  );
}

export function setHttpErrorSink(fn) {
  httpErrorSink = typeof fn === 'function' ? fn : null;
}

function notifyHttpError(error) {
  if (!httpErrorSink) return;
  const status = error?.response?.status;
  if (!(status >= 500)) return;
  const url = error?.config?.url || error?.config?.baseURL || '';
  let path = url;
  try {
    path = url.startsWith('http') ? new URL(url).pathname : url;
  } catch {
    path = url;
  }
  const started = error?.config?.metadata?.start;
  httpErrorSink({
    status,
    method: error?.config?.method,
    path,
    request_id: requestIdFromError(error),
    duration_ms: started ? Date.now() - started : undefined,
  });
}

export function installRequestId(client) {
  if (!client?.interceptors) return client;
  client.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (!config.headers['X-Request-ID'] && !config.headers['x-request-id']) {
      config.headers['X-Request-ID'] = newRequestId();
    }
    config.metadata = { ...(config.metadata || {}), start: Date.now() };
    return config;
  });
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      notifyHttpError(error);
      return Promise.reject(error);
    }
  );
  return client;
}
